import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { ProductAttribute } from 'src/app/models/company-shoes.model';

@Component({
  selector: 'app-product-attribute-icon',
  standalone: true,
  imports: [],
  templateUrl: './product-attribute-icon.component.html',
  styleUrl: './product-attribute-icon.component.scss',
})
export class ProductAttributeIconComponent {
  @Input('attribute') attribute: ProductAttribute | undefined;
  @Input() isOpen: boolean = false;

  @Output() onHoverOpen = new EventEmitter<void>();
  @Output() onHoverClose = new EventEmitter<void>();
  @Output() onClickToggle = new EventEmitter<Event>();
  @Output() onClose = new EventEmitter<Event>();

  isTouchDevice = false;

  // If a touch is detected, disable hover listeners to prevent double-firing
  @HostListener('touchstart')
  onTouch() {
    this.isTouchDevice = true;
  }

  onMouseEnter() {
    if (!this.isTouchDevice) this.onHoverOpen.emit();
  }

  onMouseLeave() {
    if (!this.isTouchDevice) this.onHoverClose.emit();
  }

  onIconClick(event: Event) {
    this.onClickToggle.emit(event);
  }

  handleClose(event: Event) {
    event.stopPropagation();
    this.onClose.emit(event);
  }

}
